import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { Toaster } from "./components/ui/sonner";

const elem = document.getElementById("root")!;

const client = new QueryClient({});

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	const root = (import.meta.hot.data.root ??= createRoot(elem));
	root.render(
		<StrictMode>
			<ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
				<QueryClientProvider client={client}>
					<Suspense
						fallback={
							<div className="w-screen h-screen flex flex-col justify-center items-center">
								Loading...
							</div>
						}
					>
						<RouterProvider router={router} />
					</Suspense>
					<Toaster />
				</QueryClientProvider>
			</ThemeProvider>
		</StrictMode>,
	);
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(
		<StrictMode>
			<ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
				<QueryClientProvider client={client}>
					<Suspense
						fallback={
							<div className="w-screen h-screen flex flex-col justify-center items-center">
								Loading...
							</div>
						}
					>
						<RouterProvider router={router} />
					</Suspense>
					<Toaster />
				</QueryClientProvider>
			</ThemeProvider>
		</StrictMode>,
	);
}
